import { useEffect } from 'react';

const DOMAIN = 'https://www.realimentanaturalvet.com';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_a1912b7e-066f-47ed-b71e-1adf7eca78cb/artifacts/nnj2xolp_Gemini_Generated_Image_fi3kv3fi3kv3fi3k-cutout.png';

export const SEOHead = ({
  title,
  description,
  canonical,
  image = DEFAULT_IMAGE,
  type = 'website',
  schema = null,
  noIndex = false,
}) => {
  useEffect(() => {
    // Set document title
    document.title = title;

    // Helper to set or update meta tag
    const setMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Helper to set or update link tag
    const setLink = (rel, href) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', rel);
        document.head.appendChild(link);
      }
      link.setAttribute('href', href);
    };

    // Basic meta tags
    setMeta('description', description);
    setMeta('robots', noIndex ? 'noindex, follow' : 'index, follow');

    // Canonical
    const canonicalUrl = canonical.startsWith('http') ? canonical : `${DOMAIN}${canonical}`;
    setLink('canonical', canonicalUrl);

    // Open Graph
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:image', image, true);
    setMeta('og:type', type, true);
    setMeta('og:site_name', 'REALimenta', true);
    setMeta('og:locale', 'es_ES', true);

    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', image);

    // Schema JSON-LD
    if (schema) {
      let scriptTag = document.querySelector('script[data-schema="page"]');
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        scriptTag.setAttribute('data-schema', 'page');
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(schema);
    }

    return () => {
      // Cleanup schema on unmount
      const scriptTag = document.querySelector('script[data-schema="page"]');
      if (scriptTag) {
        scriptTag.remove();
      }
    };
  }, [title, description, canonical, image, type, schema, noIndex]);

  return null;
};

export default SEOHead;
